import React from "react";
import Image from "next/image";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareFacebook } from "@fortawesome/free-brands-svg-icons";

const items = [
  {
    id: "facebook",
    title: "Facebook хуудас",
    href: "https://www.facebook.com/aeeblr",
    kind: "facebook",
    description: "",
    bankname: "",
  },
  {
    id: "khaanbank",
    title: "Хаан Банк",
    href: "https://www.khanbank.com", // change if needed
    kind: "image",
    src: "/khaanbank.png",
    alt: "Khan Bank",
    description: "Данс : iban 5009000 123456789",
    bankname: "Нэр : Болормаа",
  },
];

export default function SocialCards() {
  return (
    <Box
      className="mt-16
        grid grid-cols-1 gap-4 md:grid-cols-2 
        w-full max-w-5xl mx-auto 
        px-3 sm:px-4 md:px-6
      "
    >
      {items.map((item) => (
        <a
          key={item.id}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.title}
          className="
            group relative flex items-center gap-4
            rounded-2xl border-2 border-gray-200
            bg-gray-50 p-2 sm:p-4
            shadow-md hover:shadow-lg
            transition-all duration-200
            hover:-translate-y-0.5
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500
          "
        >
          {/* Left visual */}
          <div className="shrink-0">
            {item.kind === "facebook" ? (
              <FontAwesomeIcon
                icon={faSquareFacebook}
                className="
                  text-[64px] sm:text-[80px] md:text-[96px]
                  text-blue-600 group-hover:text-blue-700
                  transition-colors
                "
              />
            ) : (
              <div className="relative w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28">
                <Image
                  src={item.src}
                  alt={item.alt}
                  fill
                  className="object-contain"
                  sizes="(max-width: 768px) 6rem, (max-width: 1024px) 7rem, 7rem"
                  priority={item.id === "khaanbank"}
                />
              </div>
            )}
          </div>

          {/* Texts */}
          <div className="flex flex-col">
            <span className="text-base sm:text-lg md:text-xl font-bold text-gray-900">
              {item.title}
            </span>
            <span className="text-sm sm:text-base text-gray-600">
              {item.description}<br/>
              {item.bankname}
            </span>
          </div>

          {/* Right chevron / action hint (optional) */}
          <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-sm text-gray-500">
            Нээх →
          </div>
        </a>
      ))}
    </Box>
  );
}
